const CARD_PAYMENT_DEPOSIT_RATE = 0.3;

/** Returns the card deposit in integer minor units, using the established 30% contract. */
export const calculateCardPaymentDeposit = (orderTotal: number): number =>
  Math.round(orderTotal * CARD_PAYMENT_DEPOSIT_RATE);
